import React, { FC, useState } from "react";
import {
  Modal,
  View,
  Text,
  TouchableOpacity,
  TouchableWithoutFeedback,
  StyleSheet,
  Dimensions,
  Platform,
} from "react-native";
import { BlurView } from "expo-blur";
import { Tooltip_t } from "./common/tooltips/tooltips";

const deviceWidth = Dimensions.get("window").width;
const horizontalPadding = 20; // adjust this to match your app's layout
const modalWidth = deviceWidth - horizontalPadding * 2;

interface NotificationModalProps {
  tooltipData: Tooltip_t;
  visible: boolean;
  onClose: () => void;
}

const TooltipModal: FC<NotificationModalProps> = ({
  tooltipData,
  visible,
  onClose,
}) => {
  return (
    <Modal
      transparent
      animationType="fade"
      visible={visible}
      onRequestClose={onClose}
    >
      <TouchableWithoutFeedback onPress={onClose}>
        {/* This absolute container covers the full screen */}
        <View style={styles.absoluteContainer}>
          <BlurView intensity={50} tint="dark" style={styles.modalBackground}>
            <TouchableWithoutFeedback onPress={() => {}}>
              <View style={styles.modalContainer}>
                <Text style={styles.headerText}>{tooltipData.header}</Text>
                <View style={styles.separator} />
                <Text style={styles.bodyText}>{tooltipData.text}</Text>
                <TouchableOpacity style={styles.okButton} onPress={onClose}>
                  <Text style={styles.okButtonText}>Okay</Text>
                </TouchableOpacity>
              </View>
            </TouchableWithoutFeedback>
          </BlurView>
        </View>
      </TouchableWithoutFeedback>
    </Modal>
  );
};

const styles = StyleSheet.create({
  absoluteContainer: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
  },
  modalBackground: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
  },
  modalOverlay: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
  },
  // The modalWrapper will restrict the content's width to match your app's layout
  modalWrapper: {
    width: "100%",
    paddingHorizontal: horizontalPadding,
  },
  // The modalContainer will take up all the available width from the wrapper
  modalContainer: {
    backgroundColor: "#292D33",
    width: "90%", // Takes 90% of the available width
    maxWidth: 350, // Constrains the width on larger screens
    padding: 20,
    borderRadius: 10,
    alignItems: "center",
  },
  headerText: {
    fontFamily: "PlusJakartaSans-Bold",
    fontWeight: "700",
    fontSize: 20,
    color: "#FFFFFF",
    textAlign: "center",
    marginBottom: 10,
  },
  separator: Platform.select({
    web: {
      alignSelf: "stretch",
      borderBottomWidth: 1,
      borderStyle: "dashed",
      borderColor: "#5F6164",
      marginVertical: 10,
    },
    default: {
      alignSelf: "stretch",
      borderBottomWidth: 1,
      borderColor: "#5F6164",
      marginVertical: 10,
    },
  }),
  bodyText: {
    fontFamily: "PlusJakartaSans-Regular",
    fontWeight: "400",
    fontSize: 16,
    color: "#8D8E90",
    textAlign: "center",
    marginBottom: 20,
  },
  okButton: {
    backgroundColor: "#51B868",
    borderRadius: 45,
    width: 167,
    height: 46,
    justifyContent: "center",
    alignItems: "center",
  },
  okButtonText: {
    color: "#FFFFFF",
    fontFamily: "PlusJakartaSans-Regular",
    fontWeight: "700",
    fontSize: 16,
  },
});

export default TooltipModal;
